(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('SituacaoConfig', SituacaoConfig);

    SituacaoConfig.$inject = ['$resource'];

    function SituacaoConfig($resource) {
        var resourceUrl = 'api/situacao-config/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {method: 'GET'},
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'clonar': {
                method: 'POST',
                url: 'api/situacao-config/clonar/:clienteId',
                isArray: true
            }
        });
    }
})();
